import { Stack as MantineStack, StackProps } from '@mantine/core';
import { forwardRef } from 'react';

export interface ThemedStackProps extends StackProps {
  centered?: boolean;
  fullWidth?: boolean;
  fullHeight?: boolean;
}

const Stack = forwardRef<HTMLDivElement, ThemedStackProps>(
  ({ centered = false, fullWidth = false, fullHeight = false, align, style, children, ...rest }, ref) => {
    return (
      <MantineStack
        ref={ref}
        align={centered ? 'center' : align}
        style={{
          width: fullWidth ? '100%' : undefined,
          height: fullHeight ? '100%' : undefined,
          ...style,
        }}
        {...rest}
      >
        {children}
      </MantineStack>
    );
  }
);

Stack.displayName = 'Stack';

export default Stack;
